import 'date-fns';
import React from 'react';
import ToolBar from 'src/app/components/ToolBarPlayback';

const PlaybackMenu = ({
  listVehicle
}) => {
  
  return (
        <ToolBar
          listVehicle={listVehicle}
        />
  );
};

export default React.memo(PlaybackMenu);
